import Vue from "vue";
import elSelectLoadmore from "./el-select-loadmore"


Vue.directive('el-select-loadmore', elSelectLoadmore)